import React, { useState, useEffect } from 'react'
import { Link } from 'react-router-dom'

const CookieConsent = () => {
  const [isVisible, setIsVisible] = useState(false)
  const [showCustomPreferences, setShowCustomPreferences] = useState(false)
  const [cookiePreferences, setCookiePreferences] = useState({
    analytics: false,
    functional: false,
  })

  useEffect(() => {
    // Check if cookie preferences are already set
    const savedPreferences = localStorage.getItem('cookiePreferences')

    if (!savedPreferences) {
      // If no preferences are set, show the popup after a short delay
      const timer = setTimeout(() => {
        setIsVisible(true)
      }, 1500) // 1.5 seconds delay

      return () => clearTimeout(timer)
    }
  }, [])

  const handleToggleCustomPreferences = () => {
    setShowCustomPreferences(!showCustomPreferences)
  }

  const handleCheckboxChange = (e) => {
    setCookiePreferences({
      ...cookiePreferences,
      [e.target.name]: e.target.checked,
    })
  }

  const handleAcceptAll = () => {
    setCookiePreferences({
      analytics: true,
      functional: true,
    })

    // Save to localStorage
    localStorage.setItem(
      'cookiePreferences',
      JSON.stringify({
        essential: true,
        analytics: true,
        functional: true,
        timestamp: new Date().toISOString(),
      })
    )

    // Hide the popup
    setIsVisible(false)
  }

  const handleEssentialOnly = () => {
    setCookiePreferences({
      analytics: false,
      functional: false,
    })

    // Save to localStorage
    localStorage.setItem(
      'cookiePreferences',
      JSON.stringify({
        essential: true,
        analytics: false,
        functional: false,
        timestamp: new Date().toISOString(),
      })
    )

    // Hide the popup
    setIsVisible(false)
  }

  const handleSavePreferences = () => {
    // Save to localStorage
    localStorage.setItem(
      'cookiePreferences',
      JSON.stringify({
        essential: true,
        analytics: cookiePreferences.analytics,
        functional: cookiePreferences.functional,
        timestamp: new Date().toISOString(),
      })
    )

    // Hide the popup
    setIsVisible(false)
  }

  if (!isVisible) {
    return null
  }

  return (
    <div className='fixed bottom-0 left-0 right-0 z-50 bg-card shadow-lg p-4 md:p-6'>
      <div className='container mx-auto'>
        <div className='flex flex-col md:flex-row items-start md:items-center justify-between'>
          <div className='mb-4 md:mb-0 md:mr-6 flex-1'>
            <h3 className='text-lg font-semibold text-text-primary mb-2'>
              Configuración de Cookies
            </h3>
            <p className='text-text-secondary text-sm'>
              Utilizamos cookies para mejorar tu experiencia en nuestro sitio
              web. Puedes elegir qué cookies aceptar. Las cookies esenciales son
              necesarias para el funcionamiento del sitio y no pueden ser
              desactivadas. Para más información, consulta nuestra{' '}
              <Link
                to='/cookies-configuracion'
                className='text-primary hover:underline'
              >
                Política de Cookies
              </Link>
              .
            </p>
          </div>

          <div className='flex flex-wrap gap-2'>
            <button
              onClick={handleAcceptAll}
              className='bg-primary text-background px-4 py-2 rounded font-medium hover:bg-opacity-90 transition-colors text-sm'
            >
              Aceptar todas
            </button>
            <button
              onClick={handleEssentialOnly}
              className='bg-transparent border border-primary text-primary px-4 py-2 rounded font-medium hover:bg-primary hover:bg-opacity-10 transition-colors text-sm'
            >
              Solo esenciales
            </button>
            <button
              onClick={handleToggleCustomPreferences}
              className='bg-transparent border border-primary text-primary px-4 py-2 rounded font-medium hover:bg-primary hover:bg-opacity-10 transition-colors text-sm'
            >
              Personalizar
            </button>
          </div>
        </div>

        {showCustomPreferences && (
          <div className='mt-4 bg-background p-4 rounded-lg'>
            <div className='grid grid-cols-1 md:grid-cols-3 gap-4'>
              <div className='cookie-preference'>
                <div className='flex items-center'>
                  <input
                    type='checkbox'
                    id='popup-essential-cookies'
                    checked
                    disabled
                    className='mr-2 h-5 w-5 text-primary'
                  />
                  <label
                    htmlFor='popup-essential-cookies'
                    className='text-text-primary font-medium'
                  >
                    Cookies Esenciales
                  </label>
                </div>
                <p className='text-text-secondary text-sm mt-1 ml-7'>
                  Necesarias para el funcionamiento del sitio.
                </p>
              </div>

              <div className='cookie-preference'>
                <div className='flex items-center'>
                  <input
                    type='checkbox'
                    id='popup-analytics-cookies'
                    name='analytics'
                    checked={cookiePreferences.analytics}
                    onChange={handleCheckboxChange}
                    className='mr-2 h-5 w-5 text-primary'
                  />
                  <label
                    htmlFor='popup-analytics-cookies'
                    className='text-text-primary font-medium'
                  >
                    Cookies Analíticas
                  </label>
                </div>
                <p className='text-text-secondary text-sm mt-1 ml-7'>
                  Nos ayudan a mejorar el sitio.
                </p>
              </div>

              <div className='cookie-preference'>
                <div className='flex items-center'>
                  <input
                    type='checkbox'
                    id='popup-functional-cookies'
                    name='functional'
                    checked={cookiePreferences.functional}
                    onChange={handleCheckboxChange}
                    className='mr-2 h-5 w-5 text-primary'
                  />
                  <label
                    htmlFor='popup-functional-cookies'
                    className='text-text-primary font-medium'
                  >
                    Cookies Funcionales
                  </label>
                </div>
                <p className='text-text-secondary text-sm mt-1 ml-7'>
                  Proporcionan funcionalidades mejoradas.
                </p>
              </div>
            </div>

            <div className='mt-4 flex justify-end'>
              <button
                onClick={handleSavePreferences}
                className='bg-primary text-background px-4 py-2 rounded font-medium hover:bg-opacity-90 transition-colors text-sm'
              >
                Guardar preferencias
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  )
}

export default CookieConsent
